import React, {
  useCallback, useContext, useState,
} from 'react';
import {
  Badge, Button, Col, Modal, Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAddressCard, faBan, faBuilding, faCheck,
  faClock, faEnvelope, faPaperPlane, faUser,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import IconAlert from '../../../../components/blanks/common/IconAlert';

import SignFileData from '../../../services/SignKey/signData';
import api from '../../../../api/req';
import { CiatAppContext, WinManagerContext } from '../../../../providers';

function SignSend({
  currentSign, id, repr, isSigned = false, emailGrm,
  emailClient, onChange, onSaveWithoutExit, isDispatcher = false,
}) {
  const { auth } = useContext(CiatAppContext);

  const [modalSign, setModalSign] = useState(false);
  const [currentUnsignId, setCurrentUnsignId] = useState(null);
  const [checkSignInfo, setCheckSignInfo] = useState({
    opened: false,
    err: null,
    ownerInfo: null,
    timeInfo: null,
  });

  const navigate = useNavigate();
  const { dellComponentFromWindowsManager } = useContext(WinManagerContext);

  const onRemoveSign = useCallback(
    () => {
      // eslint-disable-next-line consistent-return
      const del = async () => {
        const r = await api.delete(`/api/akt_dvk/sign/${id}/`, auth);
        if (!r.ok && r.status !== 400) throw new Error(`${r.status} ${r.statusText}`);
      };

      del().then(() => {
        const docUrl = `/doc/aktDvk/${id}/`;
        dellComponentFromWindowsManager(docUrl);
        navigate(docUrl);
      });
    },
    [auth, dellComponentFromWindowsManager, id, navigate],
  );

  const onSendEmail = useCallback(
    (target) => {
      const sendEmail = async () => {
        const r = await api.get(`/api/akt_dvk/${target}/${id}/`, auth);
        if (!r.ok) {
          toast.error(`${r.status} ${r.statusText}`, {
            theme: 'colored',
          });
        }
      };

      sendEmail().then(() => {
        toast.success(`${repr} надіслано`, {
          theme: 'colored',
        });
      });
    },
    [auth, id, repr],
  );

  return (
    <>
      <Row className="m-3">
        <Col>

          {(isSigned && isDispatcher) && (
            <Button variant="falcon-danger" onClick={onRemoveSign}>
              Зняти підпис
            </Button>
          )}

          {((!isSigned) && isDispatcher) && (
          <Button
            variant="falcon-success"
            onClick={() => {
              if (id) {
                onSaveWithoutExit();
                setModalSign(true);
              }
            }}
          >
            Підписати
          </Button>
          )}

          <div>

            <h6 className="mb-0 text-700">
              {currentSign ? currentSign?.rank : ''}
            </h6>
            <span className="fs--2 text-500 font-sans-serif">
              {currentSign ? currentSign?.repr : ''}
            </span>
          </div>
          <div className="mt-0 pt-0">
            <Link
              className="alert-link fs--1 text-decoration-underline fst-italic"
              to="https://czo.gov.ua/verify"
              target="_blank"
            >
              Перевірити підпис
            </Link>
          </div>
        </Col>
        <Col>
          <Button
            variant="falcon-success"
            onClick={() => onSendEmail('grmemail')}
            title="Надіслати до ГРМ"
            disabled={!(isSigned && emailGrm)}
          >
            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
            Надіслати до ГРМ
          </Button>
          {emailGrm ? (
            <Badge bg="info" className="ms-2">
              {emailGrm}
            </Badge>
          ) : (
            <Badge bg="warning" className="ms-2">
              У організації відсутній email ГРМ
            </Badge>
          )}

        </Col>
        <Col>
          <Button
            variant="falcon-success"
            onClick={() => onSendEmail('clientemail')}
            title="Надіслати замовнику"
            disabled={!(isSigned && emailClient)}
          >
            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
            Надіслати контрагенту
          </Button>
          {emailClient ? (
            <Badge bg="info" className="ms-2">
              {emailClient}
            </Badge>
          ) : (
            <Badge bg="warning" className="ms-2">
              У контрагента відсутній email
            </Badge>
          )}
        </Col>
      </Row>

      {/* {loading && ( */}
      {/* <div className="d-flex align-items-center justify-content-center"> */}
      {/*  <Spinner className="me-2" /> */}
      {/*  Зачекайте будь-ласка */}
      {/* </div> */}
      {/* )} */}

      <Modal
        show={checkSignInfo.opened}
        onHide={() => setCheckSignInfo((o) => ({ ...o, opened: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Результат перевірки підпису
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {checkSignInfo.err && (
            <IconAlert variant="danger">{checkSignInfo.err}</IconAlert>
          )}
          {checkSignInfo.ownerInfo && (
            <>
              <h5 className="text-success">Документ підписано!!!</h5>
              <ul className="list-unstyled">
                <li>
                  <FontAwesomeIcon
                    icon={faUser}
                    title="Особа, що підписала документ"
                    className="me-2"
                    fixedWidth
                  />
                  {checkSignInfo.ownerInfo.subjFullName}
                  <Badge bg="info" className="ms-2">{checkSignInfo.ownerInfo.subjEDRPOUCode}</Badge>
                </li>
                {checkSignInfo.ownerInfo.subjTitle && (
                <li>
                  <FontAwesomeIcon
                    icon={faAddressCard}
                    title="Посада"
                    className="me-2"
                    fixedWidth
                  />
                  {checkSignInfo.ownerInfo.subjTitle}
                </li>
                )}
                <li>
                  <FontAwesomeIcon
                    icon={faBuilding}
                    title="Установа"
                    className="me-2"
                    fixedWidth
                  />
                  {checkSignInfo.ownerInfo.subjOrg}
                  <Badge bg="info" className="ms-2">{checkSignInfo.ownerInfo.subjDRFOCode}</Badge>
                </li>
                {checkSignInfo.ownerInfo.subjEMail && (
                <li>
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    title="Електрона адреса"
                    className="me-2"
                    fixedWidth
                  />
                  {checkSignInfo.ownerInfo.subjEMail}
                </li>
                )}
                {checkSignInfo.timeInfo.signTimeStamp && (
                <li>
                  <FontAwesomeIcon
                    icon={faClock}
                    title="Час підписання"
                    className="me-2"
                    fixedWidth
                  />
                  Підписано у
                  <span className="ms-2 text-primary">
                    {checkSignInfo.timeInfo.signTimeStamp.toLocaleDateString('uk', {
                      weekday: 'long',
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                    })}
                  </span>
                </li>
                )}
              </ul>
            </>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={modalSign}
        onHide={() => setModalSign(false)}
        size="lg"
        scrollable
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Накладання підпису
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SignFileData
            id={id}
            setModalSign={setModalSign}
            repr={repr}
            onChange={onChange}
            onSaveWithoutExit={onSaveWithoutExit}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={!!currentUnsignId}
        onHide={() => setCurrentUnsignId(null)}
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {`Знімання підпису ${currentSign?.rank} ${currentSign?.repr}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Ви дійсно бажаєте зняти підпис?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="falcon-danger" onClick={onRemoveSign}>
            <FontAwesomeIcon icon={faCheck} className="me-2" />
            Так
          </Button>
          <Button variant="falcon-success" onClick={() => setCurrentUnsignId(null)}>
            <FontAwesomeIcon icon={faBan} className="me-2" />
            Ні
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
SignSend.propTypes = {
  id: PropTypes.string.isRequired,
  repr: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSaveWithoutExit: PropTypes.func.isRequired,
  currentSign: PropTypes.shape({
    rank: PropTypes.string,
    repr: PropTypes.string,
    id: PropTypes.string,
    signed: PropTypes.bool,
  }),
  isSigned: PropTypes.bool,
  isDispatcher: PropTypes.bool,
  emailGrm: PropTypes.string,
  emailClient: PropTypes.string,
};

export default SignSend;
